import { api } from "./client";

/**
 * Note a question the help panel had no article for (STORY-226, HP-D7).
 *
 * **Clinic-scoped**: no active-branch header; the clinic comes from the token.
 * The server keeps the words, the page with record ids taken out, and the
 * clinic — never who asked.
 */
export function recordHelpQuestion(question: string, page: string): Promise<void> {
  return api<void>("/help/questions", { method: "POST", body: { question, page } });
}
